module.exports = __webpack_public_path__ + "img/ai.5010820f.svg";